import { render } from "./AddPolicy.vue?vue&type=template&id=0ace026c&scoped=true"
import script from "./AddPolicy.vue?vue&type=script&lang=js"
export * from "./AddPolicy.vue?vue&type=script&lang=js"

import "./AddPolicy.vue?vue&type=style&index=0&id=0ace026c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ace026c"]])

export default __exports__